var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminForm',{attrs:{"title":_vm.$t('admin.create.title'),"action":_vm.createAdmin,"success-msg":_vm.$t('admin.create.success'),"error-msg":_vm.$t('admin.create.error')},on:{"next":admin => _vm.$router.push({name: 'admin', params: {id: admin.id}})}})
}
var staticRenderFns = []

export { render, staticRenderFns }